
(function () {
  'use strict';
  if (window.DaLucaNylonOnePieceV378) return;
  window.DaLucaNylonOnePieceV378 = true;

  function clean(v) {
    return String(v || '').replace(/\s+/g,' ').trim();
  }

  function root() {
    return document.querySelector('.thb-product-detail.daluca-pdp--ready-nylon');
  }

  function setNumber(step, value) {
    if (!step) return;
    var node = step.querySelector('.daluca-concierge-step__number');
    if (!node) {
      node = document.createElement('span');
      node.className = 'daluca-concierge-step__number';
      step.insertBefore(node, step.firstChild);
    }
    window.DaLucaI18n.setText(node, value);
  }

  function normalizeStep02(step) {
    if (!step) return;
    step.classList.add('daluca-nylon-step-v378','daluca-nylon-step-v378--variants');

    var kicker = step.querySelector(':scope > .daluca-concierge-step__body > .daluca-concierge-kicker');
    if (kicker) kicker.style.setProperty('display','none','important');

    step.querySelectorAll('.daluca-ready-variant-master__intro').forEach(function(el){
      el.remove();
    });

    setNumber(step,'02');
  }

  function normalizeStep03(step) {
    if (!step) return;
    step.classList.add('daluca-nylon-step-v378','daluca-nylon-step-v378--addons');
    setNumber(step,'03');

    var kicker = step.querySelector('.daluca-master-addons-v366__heading .daluca-concierge-kicker');
    if (kicker) window.DaLucaI18n.setText(kicker, 'Complete the setup');

    var h = step.querySelector('.daluca-master-addons-v366__heading h3');
    if (h) window.DaLucaI18n.setText(h, 'Care & Installation');

  }

  function normalizeStep04(step) {
    if (!step) return;
    step.classList.add('daluca-nylon-step-v378','daluca-nylon-step-v378--complete');
    setNumber(step,'04');
  }

  function buildSteps(r) {
    if (!r) return;

    var fit = r.querySelector('.daluca-concierge-step--fit');
    var variants = r.querySelector('.daluca-concierge-step--variants');
    var addons = r.querySelector('.daluca-master-addons-v366');
    var complete = r.querySelector('.daluca-concierge-step--complete');

    if (!fit || !variants || !addons || !complete) return;

    // V3.81: reuse the shared Ready Editorial holder when it already exists.
    var holder = r.querySelector(':scope > .daluca-ready-steps');
    if (holder) {
      holder.classList.add('daluca-nylon-steps-v378');
      holder.setAttribute('aria-label','Nylon strap ordering steps');
    } else {
      holder = document.createElement('section');
      holder.className = 'daluca-ready-steps daluca-nylon-steps-v378';
      holder.setAttribute('aria-label','Nylon strap ordering steps');
      r.appendChild(holder);
    }

    fit.classList.add('daluca-nylon-step-v378','daluca-nylon-step-v378--fit');
    variants.classList.add('daluca-nylon-step-v378','daluca-nylon-step-v378--variants');
    addons.classList.add('daluca-nylon-step-v378','daluca-nylon-step-v378--addons');
    complete.classList.add('daluca-nylon-step-v378','daluca-nylon-step-v378--complete');

    setNumber(fit,'01');
    normalizeStep02(variants);
    normalizeStep03(addons);
    normalizeStep04(complete);

    [fit,variants,addons,complete].forEach(function(step){
      if (step.parentElement !== holder) holder.appendChild(step);
    });

    // Remove empty setup wrappers left behind by older ready-made passes.
    r.querySelectorAll('.daluca-ready-step--setup').forEach(function(wrap){
      if (!wrap.querySelector('.daluca-master-addons-v366') && !clean(window.DaLucaI18n.sourceText(wrap))) wrap.remove();
    });

    r.dataset.dalucaNylonMaster = 'v3-78';
  }

  function centerThumbnails(r) {
    if (!r) return;
    r.querySelectorAll('#Product-Thumbnails,.product-thumbnail-container').forEach(function(rail){
      rail.style.setProperty('justify-content','center','important');
      rail.style.setProperty('flex-wrap','wrap','important');
      rail.style.setProperty('overflow','visible','important');
      rail.style.setProperty('max-height','none','important');
      rail.style.setProperty('margin-left','auto','important');
      rail.style.setProperty('margin-right','auto','important');
    });
  }

  function run() {
    var r = root();
    if (!r) return;
    buildSteps(r);
    centerThumbnails(r);
  }

  var timer = 0;
  function queue() {
    clearTimeout(timer);
    timer = setTimeout(run,60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',run,{once:true});
  } else {
    run();
  }

  window.addEventListener('resize',queue,{passive:true});

  if (document.body) {
    new MutationObserver(queue).observe(document.body,{childList:true,subtree:true});
  }

  [100,250,500,900,1500,2500,4000].forEach(function(ms){ setTimeout(run,ms); });
})();

